import { JobPostings } from '@platform/client';
import { Icon } from '@platform/components';
import { CommunityCard } from '../CommunityCard';
import { ViewAllCard } from './ViewAllCard';

export const JobPostingsSegment = () => {
  const previewJobPostings = JobPostings.useGetJobPostings({ page: 0, limit: 3 });

  return (
    <div className='w-full' data-testid='jobOpeningSegment'>
      <h1 className='text-display-sm font-gray-700 pt-5'>Social impact job openings</h1>
      <div className='w-full mt-4 mb-4 bg-white rounded-xl p-4 border border-gray-100 '>
        {previewJobPostings.data?.map((jobPosting) => {
          return (
            <CommunityCard
              key={jobPosting.id}
              title={jobPosting.title}
              description={jobPosting.description}
              date={new Date(jobPosting.date)}
              subheader={
                <div className={'flex justify-left gap-1 items-center'}>
                  <Icon size='16' type='marker-pin-01' />
                  {jobPosting.location}
                </div>
              }
              link={jobPosting.url ?? undefined}
            />
          );
        })}
        <ViewAllCard link='/job-openings' />
      </div>
    </div>
  );
};
